<div class="cw__container is-fullwidth">
  <div class="cw__container__col">
    <div><ng-container #ContractsComponent></ng-container></div>
    <div><ng-container #UnauthorizedComponent></ng-container></div>
  </div>
</div>
